interface GradientOrbProps {
	className?: string;
	intensity?: "soft" | "strong";
}

export function GradientOrb({ className = "", intensity = "soft" }: GradientOrbProps) {
	const opacity = intensity === "strong" ? 0.55 : 0.35;
	return (
		<div
			aria-hidden="true"
			className={`pointer-events-none absolute rounded-full blur-3xl ${className}`}
			style={{
				background: `oklch(0.62 0.20 254 / ${opacity})`,
				animation: "float-slow 18s ease-in-out infinite",
			}}
		/>
	);
}
